module.exports = __webpack_public_path__ + "static/media/Automated baggage tracking service.9ef7f743.png";